<template>
  <div  style="background: #F5F5F5;" class="zhong">
    <hd-com></hd-com>
    <div class="bannerTab">
      <div class="" style="font-size: 24px;color: #FFFFFF;margin-left: 40px;">
        <h3 style="">食养指南</h3>
        <p style="font-size: 16px;">SHI YANG ZHI NAN</p>
      </div>
      <div class="bannerTabBtn" style="margin-right: 40px;" @click="goIndex()">
        <span  >返回首页</span>
      </div>
    </div>
    <div class="contentBox" >
      <div class="contentBoxL" style="margin-top: 20px;">
        <div class="contentBoxLSear" style="margin-bottom: 10px;display: flex;align-items: center;  padding:15px 30px;background: #FFFFFF;">
          <el-input class="searchInput" v-model="keyword" placeholder="输入关键字进行搜索..."  @keyup.enter.native="search"></el-input>
          <div class="contentBoxLBtn" @click="searchDisease">搜索</div>
        </div>
        <div style="padding: 30px;background: #FFFFFF;min-height: 600px;overflow-y: auto;"> 
          <div class="contentBoxLCon" v-for="(item, i) in diseaseList" :key="i"  @click="toDiseaseDetail(item.hashKey)" >
            <div>
              <span>·</span>{{ item.diseaseName }}
            </div>
            <i class="el-icon-arrow-right"></i>
          </div>
            <div v-if="diseaseList.length == 0" style="display: flex;justify-content: center;flex-direction: column;margin-top: 50px;">
              <img src="../../assets/img/queImg/defaultpage.png" alt="" srcset="" style="width: 300px;height: 150px;margin: auto;">
              <span style="text-align: center;margin-top: 20px;">暂无更多数据</span>
            </div>
            <el-pagination background layout="prev, pager, next,total" :page-size="15" @current-change="handleCurrentChange" :current-page.sync="currentPage" :total="total"> </el-pagination>
        </div>

      </div>
      <div class="contentBoxR" style="margin-top: 20px;">
        <div style="margin: 19px 31px 28px 23px;padding-top:20px">
            <div class="contentListTopR">
                <div class="contentListLineR"></div><span>温馨提示</span>
            </div>
            <div style="font-size: 16px;color: #FF0000;line-height: 24px;margin-top:18px">
                本平台是医患交流平台，医生根据患者自诉给出建议，内容仅供参考。 任何关于疾病、用药的建议，请以执业医师当面诊断结果为准。
            </div>
        </div>
      </div>
    </div>
    <ft-com></ft-com>
    <UpgradeMsgBox ref="upgradeMsgBox" @currentlyAvailable="getCurrentlyAvailable" :fullPath="$router.currentRoute.fullPath"></UpgradeMsgBox>
  </div>
</template>

<script>
import hdCom from "../../components/header"; //引入组件
import ftCom from "../../components/footer"; //引入组件
// import rtBar from "../../components/right";
import { Disease } from "../../components/Disease/Disease";
import { Collection } from "../../components/collection/Collection";

const ageOptions = ["婴儿", "儿童", "成年", "老人", "孕妇"];
var searchId = 0;
var pageIndex = 1;
var department = 0;
var typeId = 0;
var keyword = "";
var isClinical = 0;
var radio = "2";
export default {
  name: "DiseaseBank",
  components: {
    hdCom,
    ftCom,
  },
  data() {
    var disease = new Disease(this.TokenClient, this.Services.Disease);
    var collection = new Collection(this.TokenClient, this.Services.Statics);
    return {
      radio: "2",
      checkAll: false,
      checkedAges: [],
      ages: ageOptions,
      isCollection: false,
      isCompatibility: false,
      //疾病科室
      diseaseDepartmentList: [],
      diseaseListQt:[],
      //疾病列表
      diseaseList: [],
      total: 0,
      currentPage: 1, //初始页
      categoryName: "西医",
      rloading: [], //loading遮罩
      diseaseDomain: disease,
      collectionDomain: collection,
      currentlyAvailable: false,
      pagePath: "",
      keyword:''
    };
  },
  mounted() {
    this.$bus.$emit("isShowChangeSize");
    this.$bus.$emit("select", "disease");
    keyword = this.$route.query.keyword;
    isClinical = this.$route.query.isClinical;
    this.searchDisease(department, pageIndex);
  },
  watch: {
    $route() {
      keyword = this.$route.query.keyword;
      isClinical = this.$route.query.isClinical;
      this.searchDisease(department, pageIndex);
    },
  },
  methods: {
    handleCheckAllChange(val) {
      this.checkedAges = val ? ageOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedAgesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.ages.length;
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    onCollection: function (item) {
      var _this = this;
      var entityType = 0;
      if (item.category.indexOf("西医") != -1) {
        entityType = 1;
      }
      if (item.category.indexOf("中医") != -1) {
        entityType = 2;
      }
      _this.collectionDomain.Put(
        "disease",
        item.diseaseName,
        item.diseaseKey,
        item.diseaseId,
        entityType,
        function (data) {
          _this.$message({
            type: "success",
            message: "收藏成功!",
          });
        },
        function (err) {
          if (err.status === 400) {
            _this.$message.error("请勿重复收藏");
          }
        }
      );
    },
    onCompatibility(event) {
      let target = event.target;
      $(target).parents(".resule-item").hide("slow");
      /*this.isCompatibility = !this.isCompatibility;*/
    },
    //radio change事件
    changeHandler: function (value) {
      this.radio = value;
      this.searchDisease(0, 0);
      this.getDiseaseDepartmentList();
    },
    goSearch(item){
      var _this = this
      _this.diseaseList = item.dietaryGuides
    },
    goSearchQt(){
      var _this = this
      _this.diseaseList = _this.diseaseListQt
    },
    //右侧药品列表获取
    searchDisease(diseaseType,pageIndex, isPage = false) {
      var _this = this;
      department = diseaseType;
      // console.log(department)

      _this.rloading = this.openLoading();
      _this.diseaseDomain.getDietaryGuides(
        _this.keyword,
        pageIndex,
        function (res) {
           _this.diseaseList = res.data.results;
          _this.total = res.data.dataTotal;
        },
        function (error) {
        _this.diseaseList = []
          console.log("疾病列表请求失败!请刷新重试:", error);
        }
      );

      this.rloading.close();
      if (!isPage) this.currentPage = 1;
      // chrome
      document.body.scrollTop = 0;
      // firefox
      document.documentElement.scrollTop = 0;
      // safari
      window.pageYOffset = 0;
    },
    //分页点击事件
    handleCurrentChange: function (pageNum) {
      this.currentPage = pageNum;
      pageIndex = pageNum;
      this.searchDisease(department, true);
      // chrome
      document.body.scrollTop = 0;
      // firefox
      document.documentElement.scrollTop = 0;
      // safari
      window.pageYOffset = 0;
    },
    getCurrentlyAvailable(data) {
      console.log(data)
      this.currentlyAvailable = data;
    },

    //跳转到详情
    toDiseaseDetail(hashKey) {
      // if (!this.currentlyAvailable) {
      //   this.$refs.upgradeMsgBox.openTip();
      //   return;
      // }
      this.$router.push({
        path: "/disease/DiseaseDetailFood",
        query: {
          hashKey: hashKey,
          searchType: "disease",
        },
      });
    },
    goIndex(){
      this.$router.push({
          name: "index",
      });
    }
  },
};
</script>

<style scoped>
@import "../../assets/css/header.css";
@import "../../assets/css/footer.css";

.xi .banner {
  height: 116px;
  background: url("../../assets/img/jbk_banner.png") center no-repeat;
  width: 100%;
  position: relative;
}

.zhong .banner {
  height: 116px;
  background: url("../../assets/img/jbk_banner_zy.jpg") center no-repeat;
  width: 100%;
  position: relative;
}

.banner-text {
  width: 1200px;
  margin: 0 auto;
}

.banner-text h3 {
  padding-top: 25px;
  font-size: 26px;
  font-weight: normal;
  color: #ffffff;
}

.banner-text p {
  font-size: 18px;
  color: #ffffff;
}

/*content*/
.content {
  background: #fcfcfc;
}

.content-box {
  width: 1300px;
  margin: 0 auto;
}

.content-left {
  float: left;
  width: 320px;
  padding: 20px;
  background: #ffffff;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.06);
}

.hot-search ul li {
  float: left;
  width: 33%;
  margin-top: 10px;
}

.hot-search ul li span {
  font-size: 14px;
  color: #666666;
  cursor: pointer;
}

.hot-search ul li span:hover {
  color: #1fb7a6;
}

.zhongxi {
  margin-bottom: 15px;
}

.zhongxi li {
  float: left;
  margin-right: 10px;
  padding: 3px 0;
  width: 100px;
  border: 1px solid #cccccc;
  text-align: center;
}

.age {
  margin-top: 30px;
}

.age ul li {
  width: 33.3%;
  float: left;
  margin: 10px 0;
}

.sidenav {
  /* margin-top: 30px; */
}

.sidenav > h3 {
  width: 310px;
  padding-left: 10px;
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  color: #ffffff;
  background: #1fb7a6;
  font-weight: bold;
}

/*content-right*/
.content-right {
  float: right;
  width: 900px;
}

.result-tit {
  padding: 35px 0 25px;
  font-size: 28px;
  font-weight: bold;
  color: #222222;
}

.result-tit span,
.result-tit em {
  color: #00ab98;
  font-style: normal;
}

.result-list {
}

.resule-item {
  padding: 15px;
  margin-bottom: 10px;
  background: #ffffff;
  border: 1px solid #f5f5f5;
  box-shadow: 2px 0 3px rgba(0, 0, 0, 0.08);
}

.resule-item:hover {
  box-shadow: 3px 2px 8px rgba(0, 0, 0, 0.2);
}

.resule-info > div:nth-child(1) {
}

.resule-left {
  float: left;
  padding: 6px;
  width: 40px;
  height: 40px;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
  text-align: center;
  border-radius: 6px;
}

.resule-left.zy {
  background: #b76c12;
}

.resule-left.xy {
  background: #1fb7a6;
}

.cnname {
  max-width: 310px;
  margin-left: 10px;
  margin-right: 35px;
  cursor: pointer;
}

.cnname h3 {
  font-size: 18px;
  color: #333333;
  max-width: 310px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cnname p {
  font-size: 14px;
  color: #808080;
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.jiantou {
  margin: 0 10px;
}

.jiantou p {
  font-size: 12px;
  color: #333;
}

.jiantou .jiantou-img {
  text-align: center;
  line-height: 30px;
}

.enname {
  width: 300px;
  font-size: 18px;
  color: #06a290;
  margin-left: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.symptom {
  width: 750px;
  margin: 15px 0 0 10px;
  color: #808080;
  font-size: 14px;
}

.symptom p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.resule-item:hover .resule-star {
  opacity: 1;
  transition: all linear 0.5s;
}

.resule-star {
  transition: all linear 0.5s;
  opacity: 0;
  /* margin-right: 30px; */
}

.resule-star p span {
  font-size: 15px;
  font-weight: normal;
  cursor: pointer;
  text-decoration: underline;
}

.resule-star p span.add-cpt {
  color: #b72e0e;
}

.resule-star p span.add-col {
  color: #1fb7a6;
}

.resule-star i {
  font-size: 26px;
  color: #15aa9d;
}

/*page*/
#page {
  text-align: center;
  padding: 100px 0 30px;
}

.img-box {
  width: 800px;
  /* margin: 15px 0; */
  position: relative;
  /* height: 150px; */
  /* overflow: hidden; */
}

.img-item {
  width: 80px;
  height: 80px;
  margin-right: 5px;
}

.img-item .el-image {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  box-shadow: 2px 0 3px rgb(0 0 0 / 8%);
}

.xi .result-tit span,
.xi .result-tit em {
  color: #00ab98;
  font-style: normal;
}

.zhong .result-tit span,
.zhong .result-tit em {
  color: #b76c12;
  font-style: normal;
}

.xi .sidenav > h3 {
  width: 310px;
  padding-left: 10px;
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  color: #ffffff;
  background: #1fb7a6;
  font-weight: bold;
}

.zhong .sidenav > h3 {
  width: 310px;
  padding-left: 10px;
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  color: #ffffff;
  background: #b76c12;
  font-weight: bold;
}
</style>
<!-- 左侧导航样式 -->
<style scoped>
.sidenav /deep/ .el-submenu__title > span {
  font-size: 16px;
  font-weight: 700;
}

.sidenav /deep/ .el-submenu__title i {
  color: #ffffff;
}

.xi /deep/ .el-submenu__title {
  padding: 0 !important;
  background: #1fb7a6;
  color: #ffffff;
  margin-top: 7px;
}

.zhong /deep/ .el-submenu__title {
  padding: 0 !important;
  background: #b76c12;
  color: #ffffff;
  margin-top: 7px;
}

.xi .subtitle /deep/ .el-submenu__title {
  padding-left: 30px !important;
  background: #fff;
  color: #333;
  margin-top: 0;
  height: 36px;
  line-height: 36px;
}

.xi .subtitle /deep/ .el-submenu__title:hover {
  background: rgba(31, 183, 166, 0.2);
}

.xi .subtitle /deep/ .el-submenu__title i {
  color: #000000;
}

.xi .el-menu-item.is-active,
.xi .el-menu-item:hover {
  color: #01c2ac;
  background: rgba(31, 183, 166, 0.2);
}

.zhong .el-menu-item.is-active,
.zhong .el-menu-item:hover {
  color: #b76c12;
  background: rgba(183, 108, 18, 0.2);
}

.el-image__inner {
  height: 150px;
  width: auto;
}

.diseaseBank .el-radio.is-bordered {
  border-radius: 2px;
  width: 156px;
  text-align: center;
}

.diseaseBank .el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 5px;
}

.diseaseBank .el-radio {
  margin-right: 0;
}

.diseaseBank .el-checkbox-group {
  display: inline;
}

.diseaseBank .el-checkbox {
  width: 33.3%;
  margin: 10px 0;
}

.diseaseBank .el-checkbox__inner {
  width: 16px;
  height: 16px;
}

.diseaseBank .el-checkbox__inner::after {
  height: 9px;
  left: 5px;
  width: 4px;
}

.diseaseBank .el-badge__content.is-dot {
  height: 6px;
  width: 6px;
}

.diseaseBank .el-badge__content.is-fixed.is-dot {
  right: 0px;
  top: 11px;
}

.diseaseBank .el-submenu__title * {
  margin-left: 10px;
}

.el-menu {
  border-right: none;
}

.el-submenu__title i {
  color: #ffffff;
}

.el-menu-item,
.el-submenu__title {
  height: 48px;
  line-height: 48px;
}

.subtitle {
  border: 1px solid #f2f2f2;
}

.subtitle .el-submenu__title i {
  color: #333333;
}

.subtitle .el-submenu__title {
  padding-left: 30px !important;
  background: #ffffff;
  color: #333333;
  margin-top: 0;
  height: 36px;
  line-height: 36px;
}

.subtitle .el-submenu__title:hover {
  color: #1fb7a6;
}

.el-submenu .el-menu .sub-item {
  padding-left: 30px !important;
  height: 36px;
  line-height: 36px;
}

.el-submenu .el-menu-item {
  padding-left: 50px !important;
  height: 36px;
  line-height: 36px;
}

.el-menu-item:focus,
.el-menu-item:hover {
  background-color: #ffffff;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  border-radius: 50%;
}

.el-pagination {
  font-weight: 500;
}

/**.头部按钮样式 */
.xi /deep/ .el-radio.is-bordered.is-checked {
  border-color: #01c2ac;
}

.xi /deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #01c2ac;
  background: #01c2ac;
}

.xi /deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #01c2ac;
}

.zhong /deep/ .el-radio.is-bordered.is-checked {
  border-color: #b76c12;
}

.zhong /deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #b76c12;
  background: #b76c12;
}

.zhong /deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #b76c12;
}

.zhong /deep/ .el-radio__inner:hover {
  border-color: #b76c12;
}

.el-image-viewer__close {
  font-size: 24px;
}
.banner-right {
  position: absolute;
  right: 320px;
  top: 45px;
}
.banner-right span {
  display: inline-block;
  margin-left: 20px;
  width: 132px;
  height: 32px;
  border: 1px solid #ffffff;
  border-radius: 32px;
  box-sizing: border-box;
  text-align: center;
  color: #ffffff;
  line-height: 30px;
  cursor: pointer;
}

.banner-right span:hover {
  background-color: #ffffff;
  color: #00ab98;
}

.zhong .banner-right span:hover {
  background-color: #ffffff;
  color: #b76c12;
}
.bannerTab {
  /* width: 1200px; */
  height: 100px;
  background: linear-gradient(90deg, #EDAF60, #E1AA5B);
  border-radius: 6px;
  width: 70%;
  margin:0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* padding: 0 40px; */
  margin-top: 20px;
}
.bannerTabBtn{
  font-size: 14px;
  color: #FFFFFF;
  border-radius: 16px;
  border: 1px solid #FFFFFF;
  padding: 5px 30px;
  cursor: pointer;
}
.contentBox {
  background: #F5F5F5;
  display: flex;
  justify-content: space-between;
  width: 70%;
  margin: auto;
}
.contentBoxL {
  width: 68%;
}
.contentBoxLCon {
  background: #F7F7F7;
  border-radius: 8px;
  font-size: 18px;
  color: #333333;
  padding: 20px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.contentBoxR {
    width: 380px;
    height: 180px;
    background: #FFFFFF;
    margin-top: 20px;
    cursor: pointer;
}
.contentListTopR {
    display: flex;
    align-items: center;
}
.contentListLineR {
    width: 3px;
    height: 20px;
    background: #FF0000;
    border-radius: 2px;
}
.contentListTopR span {
   font-size: 20px;
   margin-left: 10px;
   color: #FF0000;
}
.contentBoxLBtn {
  font-size: 14px;
  color: #FFFFFF;
  background: #E5AC5D;
  border-radius: 4px;
  padding: 5px 0;
  width: 80px;
text-align: center;
margin-left: 20px;
cursor: pointer;
}
</style>
